import { useQuery } from '@tanstack/react-query';
import { API, QUERY_KEYS } from '@config';
import { useRequest, useActiveOrganizationUuid } from '@hooks';

type NodeResourcesResponse = {
  node_type_resources: NodeType[];
  action_resources: NodeAction[];
};

export const useNodeResources = (): ReturnType<typeof useQuery<NodeResourcesResponse>> => {
  const request = useRequest();
  const organizationUuid = useActiveOrganizationUuid();

  return useQuery({
    queryKey: [QUERY_KEYS.NODE_RESOURCES, organizationUuid],
    queryFn: (): Promise<NodeResourcesResponse> => {
      const url = organizationUuid
        ? `${API.FLOWS_BUILDER_NODE_RESOURCES()}?organization_uuid=${organizationUuid}`
        : API.FLOWS_BUILDER_NODE_RESOURCES();
      return request<NodeResourcesResponse>(url).then((res) => res.data);
    },
    staleTime: Infinity,
    enabled: !!organizationUuid,
  });
};